module.exports = __webpack_public_path__ + "static/shared_workspace-531a79494222f7ea01b2d64ece6c0e64.svg";